import { useWindowSize } from "@/hooks";
import { Element, useNode } from "@craftjs/core";
import { useLayoutEffect, useState } from "react";
import SpotlightButton from "../../custom/Spotlight/components/Button";
import SpotlightText from "../../custom/Spotlight/components/Text";

interface StepSpotlightProps {
    nextStep?: string;
}

const StepSpotlight = ({ nextStep }: StepSpotlightProps) => {
    const {
        connectors: { connect },
    } = useNode();

    const [width] = useWindowSize();
    const [left, setLeft] = useState(0);

    useLayoutEffect(() => {
        if (width === 2560) {
            setLeft(0);
        } else {
            const change = 2560 - width;
            setLeft(change * -0.5);
        }
    }, [width]);

    return (
        <section className="relative h-[400px] bg-primary-100" ref={(ref) => connect(ref!)}>
            <div
                className={`absolute top-0 w-full h-[400px] bg-primary-200 overflow-hidden`}
                style={{
                    left: `${left + 300}px`,
                    width: width + Math.abs(left + 300),
                    clipPath: "polygon(60px 0, 770px 0, 220px 225px)",
                }}
            />
            <div
                className={`absolute top-0 w-full h-[400px] bg-primary-200 overflow-hidden`}
                style={{
                    left: `${left + 300}px`,
                    width: width + Math.abs(left + 300),
                    clipPath: "polygon(1230px 0, 1490px 0, 1295px 85px)",
                }}
            />
            <div
                className={`absolute bottom-0 w-full h-[400px] bg-primary-200 overflow-hidden`}
                style={{
                    left: `${left + 300}px`,
                    width: width + Math.abs(left + 300),
                    clipPath: "polygon(430px 400px, 600px 270px, 770px 400px)",
                }}
            />
            <div
                className={`absolute bottom-0 w-full h-[400px] bg-primary-200 overflow-hidden`}
                style={{
                    left: `${left + 300}px`,
                    width: width + Math.abs(left + 300),
                    clipPath: "polygon(1200px 400px, 1670px 160px, 1870px 400px)",
                }}
            />
            <div className="absolute flex h-full w-full z-10">
                <div className="container mx-auto flex flex-col h-full items-center justify-center gap-6 lg:gap-10">
                    <div id="lead-spotlight" className="pt-3.5 mb-1">
                        <span className="rounded-full bg-primary-500 text-white w-14 h-14 text-4xl inline-flex items-center justify-center font-bold">
                            {nextStep}
                        </span>
                    </div>
                    <Element id="spotlight-title" is={SpotlightText} text="Découvrez tous<br />nos éléments BIM" />
                    <Element id="spotlight-button" is={SpotlightButton} text="Téléchargez plus de 100 éléments BIM" />
                </div>
            </div>
        </section>
    );
};

export default StepSpotlight;

StepSpotlight.craft = {
    displayName: "Spotlight",
    rules: {
        canDrag: () => false,
        canMoveIn: () => false,
        canMoveOut: () => false,
    },
};
